import {RichText} from 'exceljs';
import {defaultCriteriaKeyFont, defaultCriteriaValueFont} from 'src/modules/downloads/cells/fonts';
import {DEFAULT_DATE_FORMAT} from 'src/modules/downloads/cells/styles';

import {formatDate} from '@pb/kit-formatters';

export const createRichTextEntry = (keyCaption: string, value: string, suffix?: string): RichText[] => [
    {text: suffix ? `${keyCaption} ${suffix}: ` : `${keyCaption}: `, font: defaultCriteriaKeyFont},
    {text: `${value}; `, font: defaultCriteriaValueFont},
];

export const createDateRichText = (date: string, keyCaption: string, suffix: string): RichText[] => {
    return date ? createRichTextEntry(keyCaption, formatDate(date, DEFAULT_DATE_FORMAT), suffix) : [];
};
